/**
 * The always-available "Report a problem" control (Card P244).
 *
 * ⚠ THE CARD SAID "IN THE CRM HEADER". THERE IS NO HEADER.
 *
 * The authenticated shell is a Sidebar plus <main> (src/App.js) — there is no
 * header bar to put a button in. Rather than invent one four days before the
 * San Diego trip, this mounts the way the app's other always-present furniture
 * already does: once, above the page tree, beside ToastHost and
 * IdleWarningModal. That satisfies what the requirement was actually for —
 * every page, every logged-in user, never scrolled away — and it deliberately
 * does NOT go in the Sidebar's nav array, which is alphabetised at render
 * (#233), so an entry does not stay where it is put.
 */
import React, { useEffect, useState } from 'react';
import FeedbackDialog from './FeedbackDialog';
import { install, recordRoute } from '../lib/diagnostics';

export default function FeedbackLauncher({ activePage, pageContext }) {
  const [open, setOpen] = useState(false);

  /*
   * ⛔ ONE INSTALL FOR THE LIFE OF THE SESSION. The buffer has to be recording
   * long before anybody decides to report something — a diagnostics collector
   * started when the dialog opens has, by definition, missed the thing the
   * user is reporting.
   */
  useEffect(() => install(), []);

  useEffect(() => {
    if (activePage) recordRoute(activePage);
  }, [activePage]);

  return (
    <>
      <button
        type="button"
        className="fb-launcher"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        title="Report a problem or request a change"
      >
        <span className="fb-launcher-icon" aria-hidden="true">!</span>
        <span className="fb-launcher-text">Report a problem</span>
      </button>
      {open && (
        <FeedbackDialog
          onClose={() => setOpen(false)}
          pageRoute={activePage}
          pageContext={pageContext}
        />
      )}
    </>
  );
}
